import React from 'react';
import { cn } from '../../lib/utils';

export interface TimeAgoProps {
  date: Date | string;
  className?: string;
  showRelative?: boolean;
  showAbsolute?: boolean;
}

export const TimeAgo: React.FC<TimeAgoProps> = ({ 
  date, 
  className,
  showRelative = true,
  showAbsolute = false
}) => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  const now = new Date();
  const diffMs = now.getTime() - dateObj.getTime();
  
  const formatRelative = (ms: number): string => {
    const seconds = Math.floor(ms / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    
    if (days > 0) return `${days}d ago`;
    if (hours > 0) return `${hours}h ago`;
    if (minutes > 0) return `${minutes}m ago`;
    return 'Just now';
  };
  
  const formatAbsolute = (date: Date): string => {
    return date.toLocaleString('en-AU', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Australia/Sydney'
    });
  };
  
  return (
    <div className={cn('text-sm text-gray-600', className)}>
      {showRelative && (
        <span title={formatAbsolute(dateObj)}>
          {formatRelative(diffMs)}
        </span>
      )}
      {showAbsolute && showRelative && (
        <span className="ml-2 text-gray-400">•</span>
      )}
      {showAbsolute && (
        <span className={showRelative ? 'ml-2' : ''}>
          {formatAbsolute(dateObj)}
        </span>
      )}
    </div>
  );
};

export default TimeAgo;
